import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {normalizeLibelle} from '../../../../shared/core/util';

@Injectable()
export class EventPieceService {

    constructor(private http: HttpClient) {

    }

    downloadEventPieceFile(requeteId: number,
                           eventId: number,
                           eventType: string,
                           fileApiId: string,
                           fileName: string,
                           origin: string,
                           options: any): Observable<Blob> {
        const url = `/api/requetes/${requeteId}/events/${eventId}/pieces/${fileApiId}/download`;
        const fileN = !/(.+)(\.pdf)+$/.test(fileName) ? `${normalizeLibelle(fileName)}.pdf` : normalizeLibelle(fileName);
        /* return this.http.post(url, { */
        /*     origin, */
        /*     typeEvent: eventType, */
        /*     fileName: `${normalizeLibelle(fileName)}.pdf` */
        /* }, options).map(res =>  new Blob([res.blob()], {type: 'application/pdf'})); */

        return this.http.post<Blob>(url, {
            origin,
            typeEvent: eventType,
            fileName: fileN
        }, {...options} as Object);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/requete/historique-requete/timeline/timeline-element/event-piece.service.ts